import * as yup from 'yup';

export const kiwifySchema = yup.object().shape({
  access_token: yup
    .string()
    .required('Este campo é obrigatório.')
    .min(11, 'Informe um access token válido.')
    .max(200, 'Informe um access token válido.'),
});
